import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { QuizSubject } from '../../../interfaces/question.interface';
import { GamePhase } from '../../../interfaces/game-state.interface';
import { GameModeService } from '../../../_services/game-mode.service';
import { MiniGameService } from '../../../_services/mini-game.service';
import { GlobalService } from 'src/app/_services/global.service';
import { ACADEMIC_GAMES } from '../../../data/academic-games';

/**
 * Subject picker for the "Academic Skill Games" category — mirrors the
 * Trivia subject picker's look, but on select it routes to
 * `ACADEMIC_GAMES_PICK` (that subject's skill games) instead of a quiz.
 *
 * Subjects with no games yet render dimmed with a "soon" tag so the
 * shelf reads as intentionally-growing rather than broken.
 */
@Component({
  selector: 'app-academic-subject-picker',
  templateUrl: './academic-subject-picker.component.html',
  styleUrls: ['./academic-subject-picker.component.scss']
})
export class AcademicSubjectPickerComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  currLang: any = 'en';

  subjects: { key: QuizSubject; icon: string; color: string }[] = [
    { key: QuizSubject.MATH, icon: '&#128290;', color: '#4CAF50' },
    { key: QuizSubject.SCIENCE, icon: '&#128300;', color: '#2196F3' },
    { key: QuizSubject.ARABIC, icon: '&#128214;', color: '#9C27B0' },
    { key: QuizSubject.ENGLISH, icon: '&#127468;&#127463;', color: '#FF9800' },
    { key: QuizSubject.ISLAMIC, icon: '&#9770;', color: '#009688' },
    { key: QuizSubject.GENERAL, icon: '&#127758;', color: '#795548' },
  ];

  constructor(
    private gameModeService: GameModeService,
    private miniGameService: MiniGameService,
    private globalService: GlobalService
  ) {}

  ngOnInit(): void {
    this.globalService.getLang()
      .pipe(takeUntil(this.destroy$))
      .subscribe(lang => this.currLang = lang);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  gameCount(key: QuizSubject): number {
    return (ACADEMIC_GAMES[key] || []).length;
  }

  selectSubject(key: QuizSubject): void {
    this.miniGameService.setSelectedSubject(key);
    this.gameModeService.setPhase(GamePhase.ACADEMIC_GAMES_PICK);
  }

  goBack(): void {
    this.gameModeService.setPhase(GamePhase.GAME_CATEGORY);
  }
}
